import "./Button.css";
import React from "react";

export const Button = (props) => {
    return (
        <a href={props.link} target={props.target} onClick={props.onClick} id={props.id}>
            <button className={props.class}>
                {props.text} <i className={props.icon}></i>
            </button>
        </a>
    );
};
